var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49756 0C2.46672 0 1.29965e-06 2.46771 0 5.49854C-1.89949e-06 10.8315 5.18807 14.8857 5.18807 14.8857C5.37033 15.0308 5.6287 15.0308 5.81095 14.8857C5.81095 14.8857 11 10.8315 11 5.49854C11 2.46771 8.52839 0 5.49756 0ZM5.49756 3.00018C6.87198 3.00018 7.99982 4.12412 7.99982 5.49854C7.99983 6.87297 6.87199 7.99982 5.49756 7.99982C4.12313 7.99982 2.99919 6.87297 2.9992 5.49854C2.99921 4.12412 4.12314 3.00018 5.49756 3.00018Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIconActive);
export default __webpack_public_path__ + "static/media/address_icon_active.056c1645beaccabeb1aa919e097c6bee.svg";
export { ForwardRef as ReactComponent };